<template>
    <div>
        <v-card class="min-vh-90 d-flex flex-column">
            <v-card-title class="d-flex justify-content-between w-100 mb-4">
                <h5 v-if="mode === 'update'" class="ml-2 my-4">Modification d'une information supplémentaire</h5>
                <h5 v-else-if="mode === 'create'" class="ml-2 my-4">Création d'une information supplémentaire</h5>
                <v-btn icon @click="closeModal" class="ml-auto">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>

            <v-card-text>
                <v-stepper @change="setModalCurrentStep" non-linear :value="modalCurrentStep"
                           class="h-auto w-auto config-stepper">
                    <v-stepper-header>
                        <v-stepper-step editable step="1">
                            <div class="d-flex">
                                <v-icon class="mr-2">description</v-icon>
                                <span class="mt-auto mb-auto">Description</span>
                            </div>
                        </v-stepper-step>

                        <v-stepper-step editable step="2">
                            <div class="d-flex">
                                <v-icon class="mr-2">quiz</v-icon>
                                <span class="mt-auto mb-auto">Questions associées</span>
                            </div>
                        </v-stepper-step>

                        <v-stepper-step editable step="3">
                            <div class="d-flex">
                                <v-icon class="mr-2">settings</v-icon>
                                <span class="mt-auto mb-auto">Configuration</span>
                            </div>
                        </v-stepper-step>
                    </v-stepper-header>

                    <v-stepper-items>
                        <v-stepper-content step="1">
                            <v-text-field
                              outlined
                              label="Nom de l'information supplémentaire"
                              v-model="information.name"
                              hide-details
                              class="mb-2"
                              :class="{'input-error': submitted && (information.name !== null || information.name !== '') }"
                            ></v-text-field>

                            <v-text-field
                              outlined
                              label="Note explicative"
                              v-model="information.description"
                              hide-details
                              class="mb-2"
                            ></v-text-field>
                        </v-stepper-content>

                        <v-stepper-content step="2">
                            <v-alert type="info"
                                     text
                                     class="container m-0 mr-3">
                                Vous pouvez choisir d'afficher l'information supplémentaire en fonction des réponses aux
                                questions.
                                L'information supplémentaire sera visible pour les réponses cochées ci-après.
                            </v-alert>

                            <div v-if="criteriaFamilies.length === 0" class="mt-8 text-center">
                                <span>Vous n'avez configuré aucune question</span>
                            </div>

                            <div v-else v-for="family in criteriaFamilies" class="w-100 mx-2 my-4">
                                <div class="d-flex justify-content-between">
                                <span>
                                    {{ family.label }}
                                </span>

                                    <div class="d-flex">
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on, attrs }">
                                                <button @click="selectAllCriterias(family, information)" class="mr-2"
                                                        v-on="on">
                                                    <v-icon small class="select-button">done_all</v-icon>
                                                </button>
                                            </template>
                                            <span>Sélectionner tout</span>
                                        </v-tooltip>

                                        <v-tooltip top>
                                            <template v-slot:activator="{ on, attrs }">
                                                <button @click="unselectAllCriterias(family, information)" class="mr-2"
                                                        v-on="on">
                                                    <v-icon small class="select-button">remove_done</v-icon>
                                                </button>
                                            </template>
                                            <span>Désélectionner tout</span>
                                        </v-tooltip>
                                    </div>
                                </div>

                                <v-select
                                  outlined
                                  chips
                                  :items="family.criterias"
                                  v-model="information.criterias"
                                  item-text="label"
                                  item-value="id"
                                  return-object
                                  hide-details
                                  deletable-chips
                                  multiple
                                  class="mr-2"
                                ></v-select>
                            </div>
                        </v-stepper-content>

                        <v-stepper-content step="3">
                            <v-checkbox
                              label="Masquer l'information supplémentaire"
                              v-model="information.enabled"
                              :true-value="false"
                              :false-value="true"
                              hide-details
                              class="mb-2"
                            ></v-checkbox>
                        </v-stepper-content>

                    </v-stepper-items>
                </v-stepper>
            </v-card-text>

            <v-card-actions class="text-center mt-auto mb-6">
                <v-btn class="default-button mx-auto" @click="checkName" v-if="mode === 'update'">
                    Modifier l'information supplémentaire
                </v-btn>
                <v-btn class="default-button mx-auto" @click="checkName" v-if="mode === 'create'">
                    Ajouter l'information supplémentaire à mon adhésion
                </v-btn>
            </v-card-actions>
        </v-card>
    </div>
</template>

<script>
import { mapMutations, mapState } from "vuex"

export default {
    name: "CreateInformationModal",
    props: ["information", "mode"],
    data() {
        return {
            submitted: false,
        }
    },
    methods: {
        ...mapMutations("cadhConfig", ["setInformationModal", "setModalCurrentStep"]),
        closeModal() {
            this.setInformationModal(false)
        },
        updateInformation() {
            let criteriasIds = this.information.criterias && this.information.criterias.length > 0 ?
              this.information.criterias.map(function(criteria) {
                  return criteria.id
              }) : []

            let payload = {
                "cadhInformationId": this.information.id,
                "name": this.information.name,
                "description": this.information.description,
                "order": this.information.order,
                "enabled": this.information.enabled,
                "criteriasIds": criteriasIds,
            }

            this.$global.loading = true

            this.setInformationModal(false)

            this.$store.dispatch("cadhConfig/updateInformation", payload)

            this.$global.loading = false
        },
        createInformation() {
            let criteriasIds = this.information.criterias.length > 0 ?
              this.information.criterias.map(function(criteria) {
                  return criteria.id
              }) : []

            let payload = {
                "cadhConfigurationId": this.cadhConfig.id,
                "name": this.information.name,
                "description": this.information.description,
                "order": this.information.order,
                "enabled": this.information.enabled,
                "criteriasIds": criteriasIds,
            }

            this.$global.loading = true

            this.setInformationModal(false)

            this.$store.dispatch("cadhConfig/createInformation", payload)

            this.$global.loading = false
        },
        checkName() {
            this.submitted = true
            let check = this.information.name !== null && this.information.name !== ""

            if (check && this.mode === "create") {
                this.submitted = false
                this.createInformation()
            } else if (check && this.mode === "update") {
                this.submitted = false
                this.updateInformation()
            }
        },
        selectAllCriterias(family, information) {
            family.criterias.forEach(criteria => {
                let informationCriteriasIds = information.criterias.map(crit => crit.id)

                if (!informationCriteriasIds.includes(criteria.id)) {
                    information.criterias.push(criteria)
                }
            })
        },
        unselectAllCriterias(family, information) {
            family.criterias.forEach(criteria => {
                let informationCriteriasIds = information.criterias.map(crit => crit.id)

                if (informationCriteriasIds.includes(criteria.id)) {
                    let index = informationCriteriasIds.indexOf(criteria.id)

                    if (index > -1) {
                        information.criterias.splice(index, 1)
                    }
                }
            })
        },
    },
    computed: {
        ...mapState("cadhConfig", ["cadhConfig", "informationModal", "usedInCampaign", "modalCurrentStep",
            "criteriaFamilies"]),
    },
}
</script>